import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Badge } from "@/components/ui/badge";
import { ArrowLeft, Waves, MapPin, Phone, Mail, Clock, Calendar, Users } from "lucide-react";
import { Link } from "react-router-dom";
import { useState } from "react";
const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    date: "",
    time: "",
    guests: "",
    message: ""
  });
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Ici, on pourrait intégrer avec un système de réservation
    alert("Demande de réservation envoyée ! Nous vous contacterons rapidement.");
  };
  const openingHours = [{
    day: "Lundi",
    hours: "Fermé"
  }, {
    day: "Mardi",
    hours: "11h30-14h30"
  }, {
    day: "Mercredi",
    hours: "11h30-14h30 • 19h-21h30"
  }, {
    day: "Jeudi",
    hours: "11h30-14h30 • 19h-21h30"
  }, {
    day: "Vendredi",
    hours: "11h30-14h30 • 19h-21h30"
  }, {
    day: "Samedi",
    hours: "11h30-14h30 • 19h-21h30"
  }, {
    day: "Dimanche",
    hours: "11h30-14h30"
  }];
  return <div className="min-h-screen bg-background">
      {/* Navigation */}
      <nav className="fixed top-0 w-full bg-white/95 backdrop-blur-sm z-50 shadow-wave">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center space-x-2">
              <ArrowLeft className="h-6 w-6 text-primary" />
              <img src="./images/Logo restaurant .jpeg" alt="Logo La Baleine Bleue" className="h-10 w-10 object-contain" />
              <h1 className="text-2xl font-bold text-primary">La Baleine Bleue</h1>
            </Link>
            <div className="flex space-x-3 md:space-x-6 text-sm md:text-base">
              <Link to="/" className="text-foreground hover:text-primary transition-smooth">Accueil</Link>
              <Link to="/menu" className="text-foreground hover:text-primary transition-smooth">Menu</Link>
              <Link to="/about" className="text-foreground hover:text-primary transition-smooth">À propos</Link>
              <Link to="/contact" className="text-primary font-medium">Contact</Link>
            </div>
          </div>
        </div>
      </nav>

      {/* Header */}
      <section className="pt-24 pb-12 wave-gradient">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <Badge className="mb-6 ocean-gradient text-white border-0">
              <Calendar className="mr-2 h-4 w-4" />
              Réservation
            </Badge>
            <h1 className="text-5xl font-bold mb-6 text-foreground">
              Réserver votre table
            </h1>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              Contactez-nous pour réserver votre table et vivre une expérience culinaire inoubliable
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-12">
            {/* Reservation Form */}
            

            {/* Contact Information */}
            <div className="space-y-8">
              {/* Contact Details */}
              <Card className="shadow-elegant border-0">
                <CardHeader className="ocean-gradient text-white">
                  <CardTitle className="text-2xl font-bold flex items-center">
                    <MapPin className="mr-3 h-6 w-6" />
                    Informations de contact
                  </CardTitle>
                </CardHeader>
                <CardContent className="p-6">
                  <div className="space-y-6">
                    <div className="flex items-start space-x-4">
                      <MapPin className="h-6 w-6 text-primary mt-1" />
                      <div>
                        <h3 className="font-semibold text-foreground mb-1">Adresse</h3>
                        <p className="text-muted-foreground">
                          Restaurant La Baleine Bleue<br />
                          3 place du port<br />
                          11560 Saint Pierre La Mer
                        </p>
                      </div>
                    </div>
                    
                    <div className="flex items-start space-x-4">
                      <Phone className="h-6 w-6 text-primary mt-1" />
                      <div>
                        <h3 className="font-semibold text-foreground mb-1">Téléphone</h3>
                        <p className="text-muted-foreground mb-3">
                          <a href="tel:0434442464" className="hover:text-primary transition-smooth">
                            04 34 44 24 64
                          </a>
                        </p>
                        <a href="tel:0434442464">
                          <Button size="sm" className="ocean-gradient text-white shadow-wave hover:shadow-ocean transition-wave mb-2">
                            <Phone className="mr-2 h-4 w-4" />
                            Appeler maintenant
                          </Button>
                        </a>
                        <p className="text-sm text-muted-foreground">Pour vos réservations</p>
                      </div>
                    </div>
                    
                    <div className="flex items-start space-x-4">
                      
                      <div>
                        
                        
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>

              {/* Opening Hours */}
              <Card className="shadow-elegant border-0">
                <CardHeader className="ocean-gradient text-white">
                  <CardTitle className="text-2xl font-bold flex items-center">
                    <Clock className="mr-3 h-6 w-6" />
                    Horaires d'ouverture
                  </CardTitle>
                </CardHeader>
                <CardContent className="p-6">
                  <div className="space-y-4">
                    {openingHours.map((schedule, index) => <div key={index} className="flex justify-between items-center py-2 border-b border-border last:border-0">
                        <span className="font-medium text-foreground">{schedule.day}</span>
                        <span className={`text-sm ${schedule.hours === "Fermé" ? "text-destructive" : "text-muted-foreground"}`}>
                          {schedule.hours}
                        </span>
                      </div>)}
                  </div>
                  
                  <div className="mt-6 p-4 bg-secondary rounded-lg">
                    <p className="text-sm text-muted-foreground text-center">
                      <strong>Fermé :</strong> Dimanche soir, Lundi toute la journée, Mardi soir
                    </p>
                  </div>
                </CardContent>
              </Card>

              {/* Special Notes */}
              <Card className="shadow-elegant border-0">
                <CardContent className="p-6">
                  <div className="flex items-start space-x-4">
                    <Users className="h-6 w-6 text-primary mt-1" />
                    <div>
                      <h3 className="font-semibold text-foreground mb-2">Informations importantes</h3>
                      <ul className="text-sm text-muted-foreground space-y-1">
                        <li>• Réservation recommandée, surtout le week-end</li>
                        <li>• Groupes de plus de 8 personnes : nous contacter</li>
                        <li>• Terrasse disponible selon météo</li>
                        <li>• Parking gratuit à proximité</li>
                        <li>• Accessible aux personnes à mobilité réduite</li>
                      </ul>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </section>

      {/* Restaurant Images */}
      <section className="py-20 wave-gradient">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-6 text-foreground">
              Notre cadre
            </h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              Découvrez l'ambiance chaleureuse de notre restaurant
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8">
            <div className="relative overflow-hidden rounded-lg shadow-elegant">
              <img src="./images/exterieur .jpeg" alt="Terrasse extérieure" className="w-full h-64 object-cover hover:scale-110 transition-wave" />
              <div className="absolute bottom-4 left-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full">
                <span className="text-sm font-medium text-foreground">Terrasse extérieure</span>
              </div>
            </div>
            
            <div className="relative overflow-hidden rounded-lg shadow-elegant">
              <img src="./images/interieur .jpeg" alt="Salle intérieure" className="w-full h-64 object-cover hover:scale-110 transition-wave" />
              <div className="absolute bottom-4 left-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full">
                <span className="text-sm font-medium text-foreground">Salle intérieure</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-primary text-white py-12">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <div className="flex items-center justify-center space-x-2 mb-4">
              <h3 className="text-2xl font-bold">La Baleine Bleue</h3>
            </div>
            <p className="text-white/80 mb-6">
              Restaurant La Baleine Bleue • Chef Philippe Lung • Saint Pierre La Mer
            </p>
            <div className="flex justify-center space-x-6">
              <a href="#" className="text-white/80 hover:text-white transition-smooth">Facebook</a>
              
              <a href="#" className="text-white/80 hover:text-white transition-smooth">TripAdvisor</a>
            </div>
            <div className="mt-8 pt-8 border-t border-white/20">
              <p className="text-white/60 text-sm">
                © 2024 La Baleine Bleue. Tous droits réservés.
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>;
};
export default Contact;